import { makeStyles } from "tss-react/mui";
import { styled } from "@mui/material/styles";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";

const useStyles = makeStyles()((theme) => ({
  gridItems: {
    borderRadius: "14px",
    padding: "30px 20px",
    backgroundColor: "white",
    height: "100%",
    width: "100%",
  },
  parent: {
    overflow: "hidden",
  },
  headerText: {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "16px",
    display: "flex",
    lineHeight: "28px",
    marginBottom: "10px",
  },
  pageText: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: "10%",
    marginBottom: "10px",
  },
  pagesContainer: { height: "100%" },
  profile: {
    alignItems: "center",
    backgroundColor: theme.palette.primary.light,
    marginRight: 10,
    fontSize: "12px",
    fontWeight: 500,
  },
  //
  name: {
    fontWeight: 400,
    fontSize: "12px",
    fontFamily: "Poppins",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  tooltip: {
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    fontStyle: "normal",
    color: "#fff",
    lineWidth: "20px",
    background: "black",
  },
  avatarAndText: {
    display: "flex",
    alignItems: "center",
  },
  figure: {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "16px",
    color: "#272525",
    paddingTop: 5,
  },
}));

export default useStyles;

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "none",
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    fontStyle: "normal",
    color: "#fff",
    lineWidth: "20px",
    background: "black",
  },
});
export { StyledTooltip };
